<template>
    <div class="win">
        <div class="header">
            <div class="navItem">
                <i class="iconfont el-icon-setting"></i>
                <div class="title" v-bind:style="{ letterSpacing: language === 'en' ? '0px':''}">{{ $t('ems.SystemConfiguration') }}</div>
            </div>
        </div>
        <div class="content" v-loading="loading" element-loading-text="Loading" element-loading-spinner="el-icon-loading" element-loading-background="rgba(42, 43, 44, 0.6)">
            <el-form @submit.native.prevent class="table_header tableSearchForm"  size="small" label-width="150px" label-position="left">
                <div style="margin-bottom: 20px">
                    <el-form-item :label="$t('ems.loginTitle')"><el-input v-model="form.systemTitle" :placeholder="$t('ems.alarm.PleaseEnterContent')" style="width: 400px"></el-input><span style="margin-left: 10px; font-size: 14px;color: #606266">{{ $t('ems.DefaultloginTitle') }}</span></el-form-item>
                </div>
                <div style="margin-bottom: 20px">
                    <template v-for="(ems, emsinx) in form.stationNames">
                        <el-form-item :label="$t('ems.SiteName')" :key="emsinx+'site'">
                            <el-input v-model="form.stationNames[emsinx].name" :placeholder="$t('ems.alarm.PleaseEnterContent')" style="width: 250px"></el-input> --
                            <el-input v-model="form.stationNames[emsinx].nameEn" :placeholder="$t('ems.alarm.PleaseEnterContent')" style="width: 250px"></el-input>
                            <span style="margin-left: 10px; font-size: 14px;color: #606266">（中文-英文）</span>
                        </el-form-item>
                    </template>
                    <template v-for="(ems, emsinx) in form.emsNames">
                        <el-form-item :label="$t('index.EMSIndexPage')" :key="emsinx+'ems'">
                            <el-input v-model="form.emsNames[emsinx].name" :placeholder="$t('ems.alarm.PleaseEnterContent')" style="width: 250px"></el-input> --
                            <el-input v-model="form.emsNames[emsinx].nameEn" :placeholder="$t('ems.alarm.PleaseEnterContent')" style="width: 250px"></el-input>
                            <span style="margin-left: 10px; font-size: 14px;color: #606266">（中文-英文）</span>
                        </el-form-item>
                    </template>
                    <template v-for="(ems, emsinx) in form.bmsNames">
                        <el-form-item :label="$t('index.BMS')"  :key="emsinx+'bms'">
                            <el-input v-model="form.bmsNames[emsinx].name" :placeholder="$t('ems.alarm.PleaseEnterContent')" style="width: 250px"></el-input> --
                            <el-input v-model="form.bmsNames[emsinx].nameEn" :placeholder="$t('ems.alarm.PleaseEnterContent')" style="width: 250px"></el-input>
                            <span style="margin-left: 10px; font-size: 14px;color: #606266">（中文-英文）</span>

                        </el-form-item>
                    </template>
                    <template v-for="(ems, emsinx) in form.containerNames">
                        <el-form-item :label="$t('index.container')"  :key="emsinx+'con'">
                            <el-input v-model="form.containerNames[emsinx].name" :placeholder="$t('ems.alarm.PleaseEnterContent')" style="width: 250px"></el-input> --
                            <el-input v-model="form.containerNames[emsinx].nameEn" :placeholder="$t('ems.alarm.PleaseEnterContent')" style="width: 250px"></el-input>
                            <span style="margin-left: 10px; font-size: 14px;color: #606266">（中文-英文）</span>

                        </el-form-item>
                    </template>
                </div>


                <el-form-item :label="$t('ems.LoginpageLOGO')" style="margin-right: 100px">
                    <el-upload
                            class="avatar-uploader-login"
                            action="/api/blade-wems/config/upload"
                            :show-file-list="false"
                            :headers="headers"
                            :on-success="handleAvatarSuccess"
                            :before-upload="beforeAvatarUpload">
                        <div v-if="form.loginLogo"  class="avatar">
                            <img :src="baseUrl + form.loginLogo">
                        </div>
                        <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                        <div slot="tip" class="el-upload__tip">{{ $t('ems.Onlypngfilesuploadedrecommended') }}</div>
                    </el-upload>
                </el-form-item>
                <el-form-item :label="$t('ems.HomeLOGO')" style="margin-right: 100px">
                    <el-upload
                            class="avatar-uploader-index"
                            action="/api/blade-wems/config/upload"
                            :show-file-list="false"
                            :headers="headers"
                            :on-success="handleAvatarSuccess1"
                            :before-upload="beforeAvatarUpload1">
                        <div v-if="form.navLogo"  class="avatar">
                            <img :src="baseUrl + form.navLogo">
                        </div>
                        <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                        <div slot="tip" class="el-upload__tip">{{ $t('ems.Onlypngfilescanbeuploadedrecommended') }}</div>
                    </el-upload>
                </el-form-item>
                <el-form-item :label="$t('ems.webpageicon')">
                    <el-upload
                            class="avatar-uploader-icon"
                            action="/api/blade-wems/config/upload"
                            :data="{customFileName: 'icon.png'}"
                            :show-file-list="false"
                            :headers="headers"
                            :on-success="handleAvatarSuccess2"
                            :before-upload="beforeAvatarUpload2">
                        <div v-if="form.icon"  class="avatar">
                            <img :src="baseUrl + form.icon">
                        </div>
                        <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                        <div slot="tip" class="el-upload__tip">{{ $t('ems.Onlypnguploaded2m') }}</div>
                    </el-upload>
                </el-form-item>
                <el-form-item :label="$t('systemSetting.equipment')">
                    <el-upload
                            key="con"
                            class="avatar-uploader-con"
                            action="/api/blade-wems/config/upload"
                            :show-file-list="false"
                            :headers="headers"
                            :on-success="handleAvatarSuccess3"
                            :before-upload="beforeAvatarUpload">
                        <div v-if="form.containerPic"  class="avatar">
                            <img :src="baseUrl + form.containerPic">
                        </div>
                        <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                        <div slot="tip" class="el-upload__tip">{{ $t('ems.conPic') }}</div>
                    </el-upload>
                </el-form-item>
                <el-form-item :label="$t('systemSetting.bmsEquipment')">
                    <el-upload
                            key="conmin"
                            class="avatar-uploader-conmin"
                            action="/api/blade-wems/config/upload"
                            :show-file-list="false"
                            :headers="headers"
                            :on-success="handleAvatarSuccess4"
                            :before-upload="beforeAvatarUpload">
                        <div v-if="form.containerSmallPic" class="avatar">
                            <img :src="baseUrl + form.containerSmallPic">
                        </div>
                        <i v-else class="el-icon-plus avatar-uploader-icon">{{form.containerSmallPic}}</i>
                        <div slot="tip" class="el-upload__tip">{{ $t('ems.conPicMax') }}</div>
                    </el-upload>
                </el-form-item>
            </el-form>
            <div class="subminBox">
                <div class="btn btn_active" @click="reset"><i class="iconfont icon-reset"></i><span>{{ $t('ems.alarm.reset') }}</span></div>
                <div class="btn btn_active" style="margin-right: 0" @click="save"><i class="iconfont icon-baocun"></i><span>{{ $t('ems.strategy.save') }}</span></div>
            </div>
        </div>
    </div>
</template>

<script>
    import { mapGetters } from "vuex";
    import { saveSysConfig, getContainerPic, setContainerPic, getStationMoinfo, setStationMoinfo } from '@/api/spms';
    import spmsweb from '@/config/spmsweb';
    import { getStore } from "@/utils/store";
    import { Base64 } from 'js-base64';
    import i18n from "@/lang";

    export default {
        name: "mainSys",
        data(){
            return{
                opacity: 0,
                loading: false,
                baseUrl: imgBaseUrl ,
                form: {
                    icon: '',
                    loginLogo: '',
                    navLogo: '',
                    systemTitle: '',
                    containerPic: '',
                    containerSmallPic: '',
                    "stationNames": [
                        {
                            "id": 0,
                            "name": "",
                            "nameEn": ""
                        }
                    ],
                    "emsNames": [
                        {
                            "id": 0,
                            "name": "",
                            "nameEn": ""
                        }
                    ],
                    "bmsNames": [
                        {
                            "id": 0,
                            "name": "",
                            "nameEn": ""
                        }
                    ],
                    "containerNames": [
                        {
                            "id": 0,
                            "name": "",
                            "nameEn": ""
                        }
                    ]
                }
            }
        },
        computed: {
            ...mapGetters(["language"]),
        },
        created(){
            this.headers = {
                Authorization: `Basic ${Base64.encode(
                    `${spmsweb.clientId}:${spmsweb.clientSecret}`
                )}`,
                "Blade-Auth": "bearer " + getStore({ name: "access_token" }),
                // 'Content-Type': 'application/json'
            };
            const systemSet = getStore({ name: "systemSet" });
            this.form = systemSet;
            getContainerPic().then(res => {
                if (res && res.data && res.data.data) {
                    this.form.containerPic = res.data.data.containerPic;
                    this.form.containerSmallPic = res.data.data.containerSmallPic;
                    this.$forceUpdate();
                }
            });
            getStationMoinfo().then(res => {
                if (res && res.data && res.data.data) {
                    this.form = { ... this.form, ...res.data.data };
                    this.$forceUpdate();
                }
            })
        },
        mounted(){
            setTimeout(() => {
                this.opacity = 1;
            },200);
        },
        methods: {
            handleAvatarSuccess(res) {
                this.form.loginLogo =  res.data;
            },
            beforeAvatarUpload(file) {
                const isJPG = file.type === 'image/png';
                if (!isJPG) {
                    this.$message.error(i18n.t('ems.uploadedAvatarPicturetype'));
                }
                return isJPG;
            },
            handleAvatarSuccess1(res) {
                this.form.navLogo = res.data;
                console.log( this.form.imageUrl)
            },
            beforeAvatarUpload1(file) {
                const isJPG = file.type === 'image/png';
                if (!isJPG) {
                    this.$message.error(i18n.t('ems.uploadedAvatarPicturetype'));
                }
                return isJPG;
            },
            handleAvatarSuccess2() {
                this.form.icon = "/upload/icon.png";
                console.log( this.form.imageUrl)
            },
            beforeAvatarUpload2(file) {
                const isJPG = file.type === 'image/png';
                const isLt2M = file.size / 1024 / 1024 < 2;

                if (!isJPG) {
                    this.$message.error(i18n.t('ems.uploadedAvatarPicturetype'));
                }
                if (!isLt2M) {
                    this.$message.error(i18n.t('ems.sizeUploadedPictureExceed'));
                }
                return isJPG && isLt2M;
            },


            handleAvatarSuccess3(res) {
                this.form.containerPic =  res.data;
                this.$forceUpdate();
            },

            handleAvatarSuccess4(res) {
                this.form.containerSmallPic =  res.data;
                this.$forceUpdate();
            },


            async save() {
                const params = {...this.form};
                this.loading = true;
                await saveSysConfig(params);
                await setContainerPic({ containerPic: this.form.containerPic, containerSmallPic: this.form.containerSmallPic});
                await setStationMoinfo(params);
                this.loading = false;
                this.$message.success(i18n.t("index.updateSuccessful") + "  "+i18n.t("index.pleaseLogin"));
            },
            reset(){
                this.loading = true;
                setTimeout(() => {
                    this.loading = false;
                }, 2000);
                const systemSet = getStore({ name: "systemSet" });
                this.form = {...systemSet};
                    getContainerPic().then(res => {
                        if (res && res.data && res.data.data) {
                            this.form.containerPic = res.data.data.containerPic;
                            this.form.containerSmallPic = res.data.data.containerSmallPic;
                            this.$forceUpdate();
                        }
                    })
                getStationMoinfo().then(res => {
                    if (res && res.data && res.data.data) {
                        this.form = { ... this.form, ...res.data.data };
                        this.$forceUpdate();
                    }
                })
            }
        }
    }
</script>

<style scoped lang="scss">
    @import "../../styles/site";
    .win{
        width: 100%;
        height: 100%;
        .header{
            height: 52px;
            background-color: var(--nav_inner);
            position: relative;
            .navItem{
                height: 100%;
                color: $font_bright_blue_title;
                display: flex;
                align-items: center;
                transition: all 0.3s linear;
                i{
                    font-size: 22px;
                    margin: 3px 20px 0;
                }
                .title{
                    letter-spacing: 3px;
                    font-size: 22px;
                }
                .desc{
                    margin-left: 24px;
                    font-size: 16px;
                    color: $_128_128_128;
                }
            }
        }
        .content{
            overflow: hidden;
            height: calc(100% - 52px);
            box-sizing: border-box;
            padding: 20px;
            position: relative;
            .table_header{
                padding: 40px 50px 0px 50px;
                height: 760px;
                overflow-y: auto;
                background-color: var(--nav);
                border: #595959 solid 1px;
                box-sizing: border-box;

                color: var(--input_font);
                position: relative;
            }
            .subminBox{
                width: 100%;
                text-align: center;
                position: absolute;
                bottom: 15px;
                left: 0;
            }
        }

    }
</style>
<style lang="scss">
    .table_header {
        .el-form-item__label {
            color: var(--input_font) !important;
            font-size: 16px !important;
        }

        .avatar-uploader-login {
            .el-upload {
                border: 1px dashed  rgb(191, 191, 191);
                border-radius: 6px;
                cursor: pointer;
                position: relative;
                overflow: hidden;
            }
            .el-upload:hover {
                border-color: #409EFF;
            }
            .avatar-uploader-icon {
                font-size: 28px;
                color: #8c939d;
                width: 450px;
                height: 120px;
                line-height: 120px;
                text-align: center;
            }
            .avatar {
                width: 450px;
                height: 120px;
                text-align: left;

                img{
                    width: 450px;
                    max-height: 120px;
                }
            }
        }
        .avatar-uploader-index {
            .el-upload {
                border: 1px dashed  rgb(191, 191, 191);
                border-radius: 6px;
                cursor: pointer;
                position: relative;
                overflow: hidden;
            }
            .el-upload:hover {
                border-color: #409EFF;
            }
            .avatar-uploader-icon {
                font-size: 28px;
                color: #8c939d;
                width: 250px;
                height: 80px;
                line-height: 80px;
                text-align: center;
            }
            .avatar {
                width: 250px;
                height: 80px;
                text-align: left;

                img{
                    max-width: 250px;
                    height: 80px;
                }
            }
        }
        .avatar-uploader-icon {
            .el-upload {
                border: 1px dashed  rgb(191, 191, 191);
                border-radius: 6px;
                cursor: pointer;
                position: relative;
                overflow: hidden;
            }
            .el-upload:hover {
                border-color: #409EFF;
            }
            .avatar-uploader-icon {
                font-size: 28px;
                color: #8c939d;
                width: 128px;
                height: 128px;
                line-height: 128px;
                text-align: center;
            }
            .avatar {
                width: 128px;
                height: 128px;
                img{
                    width: 128px;
                    height: 128px;
                }
            }
        }


        .avatar-uploader-con {
            .el-upload {
                border: 1px dashed  rgb(191, 191, 191);
                border-radius: 6px;
                cursor: pointer;
                position: relative;
                overflow: hidden;
            }
            .el-upload:hover {
                border-color: #409EFF;
            }
            .avatar-uploader-icon {
                font-size: 28px;
                color: #8c939d;
                width: 720px;
                height: 320px;
                line-height: 320px;
                text-align: center;
            }
            .avatar {
                width: 720px;
                height: 320px;
                img{
                    width: 720px;
                    height: 320px;
                }
            }
        }

        .avatar-uploader-conmin {
            .el-upload {
                border: 1px dashed  rgb(191, 191, 191);
                border-radius: 6px;
                cursor: pointer;
                position: relative;
                overflow: hidden;
            }
            .el-upload:hover {
                border-color: #409EFF;
            }
            .avatar-uploader-icon {
                font-size: 28px;
                color: #8c939d;
                width: 180px;
                height: 160px;
                line-height: 160px;
                text-align: center;
            }
            .avatar {
                width: 180px;
                height: 160px;
                img{
                    width: 180px;
                    height: 160px;
                }
            }
        }
    }
</style>